/* ========================================================================
	* DOM-based Routing
	* Based on http://goo.gl/EUTi53 by Paul Irish
	*
	* Only fires on body classes that match. If a body class contains a dash,
	* replace the dash with an underscore when adding it to the object below.
	*
	* .noConflict()
	* The routing is enclosed within an anonymous function so that you can
	* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

(function($) {
	
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				
				$('.flexslider').flexslider({
					slideshow: true,
					slideshowSpeed: 5000,
					pauseOnAction: true,
					pauseOnHover: true,
					animation: "fade",
					animationLoop: true,
					directionNav: false, 
					controlNav: false,
					itemWidth: 210,
					itemMargin: 5,
					minItems: 1,
					maxItems: 1,
					touch: true,  
					useCSS: false
				});
				$('.flexslider2').flexslider({
					slideshow: true,
					slideshowSpeed: 5000,
					pauseOnAction: true,
					pauseOnHover: true,
					animation: "fade",
					animationLoop: true,
					directionNav: true, 
					controlNav: false,
					itemWidth: 210,
					itemMargin: 5,
					minItems: 1,
					maxItems: 1,
					touch: true,  
					useCSS: false
				});
				
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
				$('.flexslider').flexslider({
					slideshow: true,
					slideshowSpeed: 5000,
					pauseOnAction: true,
					pauseOnHover: true,
					animation: "slide",
					animationLoop: true,
					directionNav: true, 
					controlNav: true,
					itemWidth: 210,
					itemMargin: 5,
					minItems: 1,
					maxItems: 1,
					touch: true,  
					useCSS: false
				});
			}
		},
		'contact_us': {
			init: function() {
				google.maps.event.addDomListener(window, 'load', init);
				var map;
				function init() {
					var mapOptions = {
						center: new google.maps.LatLng(56.553788, -2.616966),
						zoom: 15,
						zoomControl: true,
						zoomControlOptions: {
							style: google.maps.ZoomControlStyle.DEFAULT,
						},
						disableDoubleClickZoom: true,
						mapTypeControl: true,
						mapTypeControlOptions: {
							style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
						},
						scaleControl: true,
						scrollwheel: false,
						panControl: true,
						streetViewControl: true,
						draggable: true,
						overviewMapControl: true,
						overviewMapControlOptions: {
							opened: false,
						},
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						styles: [{"featureType":"all","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#c4c4c4"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#707070"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21},{"visibility":"on"}]},{"featureType":"poi.business","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#be2026"},{"lightness":"0"},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"hue":"#ff000a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#575757"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.stroke","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#999999"}]},{"featureType":"road.local","elementType":"labels.text.stroke","stylers":[{"saturation":"-52"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
					}
					var mapElement = document.getElementById('map');
					var map = new google.maps.Map(mapElement, mapOptions);
					var locations = [['Frasers Bodyshop', 'undefined', 'undefined', 'undefined', 'undefined', 56.553788, -2.616966, 'https://mapbuildr.com/assets/img/markers/default.png']];
					for (i = 0; i < locations.length; i++) {
						if (locations[i][1] === 'undefined') {
							description = '';
							} else {
							description = locations[i][1];
						}
						if (locations[i][2] === 'undefined') {
							telephone = '';
							} else {
							telephone = locations[i][2];
						}
						if (locations[i][3] === 'undefined') {
							email = '';
							} else {
							email = locations[i][3];
						}
						if (locations[i][4] === 'undefined') {
							web = '';
							} else {
							web = locations[i][4];
						}
						if (locations[i][7] === 'undefined') {
							markericon = '';
							} else {
							markericon = locations[i][7];
						}
						marker = new google.maps.Marker({
							icon: markericon,
							position: new google.maps.LatLng(locations[i][5], locations[i][6]),
							map: map,
							title: locations[i][0],
							desc: description,
							tel: telephone,
							email: email,
							web: web
						});
						link = '';
						bindInfoWindow(marker, map, locations[i][0], description, telephone, email, web, link);
					}
					function bindInfoWindow(marker, map, title, desc, telephone, email, web, link) {
						var infoWindowVisible = (function () {
							var currentlyVisible = false;
							return function (visible) {
								if (visible !== undefined) {
									currentlyVisible = visible;
								}
								return currentlyVisible;
							};
						}());
						iw = new google.maps.InfoWindow();
						google.maps.event.addListener(marker, 'click', function () {
							if (infoWindowVisible()) {
								iw.close();
								infoWindowVisible(false);
								} else {
								var html = "<div><h3>Frasers Bodyshop</h3><p>Unit 4, 7 Peasiehill Road, Elliot Industrial Estate Arbroath, Angus, DD11 2NJ<br></div><a class='mapButn' href='tel:+441241874624' title='Call Us'>Call Us</a><a class='mapButn' href='https://www.google.co.uk/maps/place/Frasers+Bodyshop+Arbroath/@56.5538,-2.6191657,17z/data=!3m1!4b1!4m5!3m4!1s0x48868cc2534be88b:0xe9136fa5f7a4f634!8m2!3d56.5538!4d-2.616977?hl=en' target='_blank' title='Find Us'>Directions</a></p></div>";
								iw = new google.maps.InfoWindow({content: html});
								iw.open(map, marker);
								infoWindowVisible(true);
							}
						});
						google.maps.event.addListener(iw, 'closeclick', function () {
							infoWindowVisible(false);
						});
					}
					google.maps.event.addListener(map, 'click', function (event) {
						this.setOptions({scrollwheel: true});
					});
					google.maps.event.addListener(map, 'mouseout', function (event) {
						this.setOptions({scrollwheel: false});
					});
				}
			}
		}
	};
	
	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';
			
			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');
			
			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});
			
			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};
	
	// Load Events
	$(document).ready(UTIL.loadEvents);
	
})(jQuery); // Fully reference jQuery after this point.
